import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from './useUniversalNavContext';
export const useQueryAccountRestriction = (currentAccountId) => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['accountRestriction', currentAccountId],
        queryFn: async () => {
            if (!currentAccountId) {
                return undefined;
            }
            const url = new URL(`/api/checkpoint/v1/account-restrictions/`, apiHostname || window.location.origin);
            const response = await fetch(url.toString(), {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            return json;
        },
        staleTime: 1000 * 10,
        enabled: !!currentAccountId,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryAccountRestriction.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
